import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {
    DateRange,
  DefaultMatCalendarRangeStrategy,
  MAT_DATE_RANGE_SELECTION_STRATEGY, MAT_RANGE_DATE_SELECTION_MODEL_PROVIDER, MatCalendar,
} from '@angular/material/datepicker';
import * as moment from 'moment';
import { DatetimeRange } from '../datetime-selection-model';

@Component({
  selector: 'app-calendar-range-picker',
  templateUrl: './calendar-range-picker.component.html',
  styleUrls: ['./calendar-range-picker.component.css'],
  providers: [
    MAT_RANGE_DATE_SELECTION_MODEL_PROVIDER ]
})
export class CalendarRangePickerComponent<D> implements OnInit {

  @ViewChild(MatCalendar) calendar: MatCalendar<Date>;

  range: DateRange<D>

  @Input()
  get selectedRange(): DatetimeRange<D> {
    return this._selectedRange;
  }
  set selectedRange(value: DatetimeRange<D>) {
    this._selectedRange = value;
    this.range = new DateRange<D>(value.start, value.end);
  }
  private _selectedRange: DatetimeRange<D>;

  @Output() selectedRangeChange = new EventEmitter<DatetimeRange<D>>();

  ngOnInit(): void {
  }

  selectedChange($event) {
    const m = moment($event);
    if (!this.isNullOrUndefined(this.selectedRange.end)) {
      const start = $event; // this.selectedRange.start;
      // @ts-ignore the parser thinks that this is a date, but it is a moment.js object, so this will work
      // start.set(m.toObject());
      this.selectedRange = new DatetimeRange<D>(start, undefined);
      this.selectedRangeChange.emit(this.selectedRange);
    } else {
      const end = (!this.isNullOrUndefined(this.selectedRange.end)) ? this.selectedRange.end : m.toDate();
      // @ts-ignore the parser thinks that this is a date, but it is a moment.js object, so this will work
      // end.set(m.toObject());
      // @ts-ignore the parser thinks that this is a date, but it is a moment.js object, so this will work
      this.selectedRange = new DatetimeRange<Date>(this.selectedRange.start, end);
      if (this.selectedRange.end < this.selectedRange.start) {
        this.selectedRange = new DatetimeRange<D>(this.selectedRange.end, this.selectedRange.start);
      }
      this.selectedRangeChange.emit(this.selectedRange);
    }
  }

  isNullOrUndefined(value: any): boolean {
    return value == null || value == undefined;
  }

}
